import { Injectable } from '@angular/core';

import { GraphQLService } from '@app/services';
import { 
    mutationAddStoryAnalytics
} from '@app/graphql-queries';

@Injectable({
  providedIn: 'root'
})
export class PwaAnalyticsService {
    
    constructor(
        private graphQLService: GraphQLService
    ) { }
    
    async addStoryAnalytics(ambassadorID: string, storyID: string): Promise<any|null>{
        let data: any|null = null;
        let response = await this.graphQLService.mutate({   
            mutation: mutationAddStoryAnalytics,
            variables: {
                ambassadorID: ambassadorID,
                storyID: storyID
            }       
        });     
        if(response?.data?.AddStoryAnalytics){
            data = response?.data?.AddStoryAnalytics;
        }
        return data;
    }
    
}
